import { FormsModule } from '@angular/forms'
import { NgModule } from '@angular/core'
import { RouterModule, Router, RouteReuseStrategy } from '@angular/router'
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http'
import 'hammerjs'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { StoreRouterConnectingModule, RouterState } from '@ngrx/router-store'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { CookieService } from 'ngx-cookie-service';

import { environment } from '@env/environment'
import { CoreModule } from '@core/core.module'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { AuthModule } from '@auth/auth.module'
import { RequestInterceptorService } from '@services/request-interceptor/request-interceptor.service'
import { SharedModule } from '@shared/shared.module'
import { Globals } from '@core/global/globals'
import { reducers, metaReducers } from '@core/store'
import { CustomAppModule } from './custom-app.module'
import { FeatureEffects } from '@core/store/feature-effects'
import { CustomSerializer } from '@core/store/router-serializer'
import { MenuService } from './core/services/menu/menu.service'
import { TranslatorService } from './core/services/translator/translator.service'
import { LocationStrategy, PathLocationStrategy } from '@angular/common'
import { authService } from './core/services-api/auth.service'
import { ToastModule } from 'primeng/toast'
import { MessageService } from 'primeng/api'

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/locale/', '.json')
}
/**
 * The main application module
 *
 * @stable
 */
@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    SharedModule,
    RouterModule,
    AppRoutingModule,
    CoreModule,
    AuthModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    /**
     * ngrx store root
     */
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    EffectsModule.forRoot([FeatureEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    /**
     * @ngrx/router-store keeps router state up-to-date in the store.
     */
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer,
      routerState: RouterState.Minimal,
    }),
    CustomAppModule,
  ],
  providers: [
    { provide: 'menuService', useClass: MenuService },
    { provide: 'translatorService', useClass: TranslatorService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
    { provide: 'environment', useValue: { ...environment } },
    { provide: LocationStrategy, useClass: PathLocationStrategy },

    Globals, CookieService
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule { }
